import { useEffect, useState } from "react";
import { Navigate, useParams } from "react-router";
import { ApiError, useApi, useFetcher, type Me } from "../api.js";
import { ErrorBox, Loading } from "../components/ui.js";

/**
 * Links without an organisation (GitHub check "Details", CLI output) resolve
 * by trying each of the user's organisations.
 */
export function Resolve({ kind }: { kind: "pipelines" | "deployments" | "projects" }) {
  const { id = "" } = useParams();
  const me = useApi<Me>("/v1/me");
  const fetcher = useFetcher();
  const [target, setTarget] = useState<string | null>();

  useEffect(() => {
    if (!me.data) return;
    const state = { cancelled: false };
    void (async () => {
      for (const org of me.data?.organisations ?? []) {
        try {
          await fetcher(`/v1/orgs/${org.slug}/${kind}/${id}`);
          if (!state.cancelled) setTarget(`/o/${org.slug}/${kind}/${id}`);
          return;
        } catch (e) {
          if (!(e instanceof ApiError) || e.status !== 404) break;
        }
      }
      if (!state.cancelled) setTarget(null);
    })();
    return () => {
      state.cancelled = true;
    };
  }, [me.data, fetcher, kind, id]);

  if (target) return <Navigate to={target} replace />;
  if (target === null) return <ErrorBox error={new Error(`Not found in your organisations: ${id}`)} />;
  return me.error ? <ErrorBox error={me.error} /> : <Loading />;
}
